import React from 'react';
import Hero from '../components/home/Hero';
import PillarsOverview from '../components/home/PillarsOverview';
import ProductsSection from '../components/home/ProductsSection';
import GallerySection from '../components/home/GallerySection';
import TechNote from '../components/home/TechNote';
import CTA from '../components/home/CTA';

const HomePage: React.FC = () => (
  <>
    <Hero />
    <PillarsOverview />
    <ProductsSection />
    <GallerySection />
    <TechNote />
    <CTA />
  </>
);

export default HomePage;
